<template>
  <div class="bg">
    <div class="container">
      <div class="box p-2 m-t1 border-round">
        <div class="car-title">
          <span>报名学员</span>
        </div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="已支付" name="first">
            <div class="m-t2">
              <el-table
                :data="userData"
                size="medium"
                height="400px"
                @selection-change="handleSelectionChange"
              >
                <el-table-column type="selection" width="55"> </el-table-column>
                <el-table-column prop="userName" label="姓名">
                </el-table-column>
                <el-table-column prop="userGender" label="性别">
                </el-table-column>
                <el-table-column prop="userMobile" label="手机号">
                </el-table-column>
                <el-table-column prop="userEmail" label="电子邮箱">
                </el-table-column>
                <el-table-column prop="userCompany" label="工作单位">
                </el-table-column>
              </el-table>
              <div class="ntns">
                <el-button
                  type="primary"
                  @click="Applyreud"
                  :disabled="multipleSelection.length == 0"
                  >申请退费</el-button
                >
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="已退费" name="second">
            <div class="m-t2">
              <el-table :data="tuifData" size="medium">
                <el-table-column width="100px" label="状态">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.status == 0"> 审核中 </el-tag>
                    <el-tag type="danger" v-if="scope.row.status == 1">
                      拒绝
                    </el-tag>
                    <el-tag type="success" v-if="scope.row.status == 2">
                      通过
                    </el-tag>
                    <el-tag type="warning" v-if="scope.row.status == 3">
                      处理完毕
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="refundNo" width="230px" label="退费单号">
                </el-table-column>
                <el-table-column prop="orderId" width="100px" label="订单号">
                </el-table-column>
                <el-table-column
                  prop="totoalAmount"
                  width="150px"
                  label="退款金额"
                >
                </el-table-column>
                <el-table-column prop="reason" width="150px" label="退款原因">
                </el-table-column>
                <el-table-column prop="remarks" width="200px" label="备注">
                </el-table-column>

                <el-table-column prop="yewuNote" label="业务备注">
                </el-table-column>

                <el-table-column prop="userEmail" label="明细">
                  <template slot-scope="scope">
                    <el-link
                      type="primary"
                      :underline="false"
                      @click="mingxi(scope.row)"
                      >查看明细</el-link
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
        </el-tabs>

        <el-dialog
          title="退费申请"
          :visible.sync="dialogVisible"
          :close-on-click-modal="false"
          width="1000px"
          :center="true"
          :show-close="false"
        >
          <div>
            <el-row>
              <el-col :span="12">
                <h3>订单号</h3>
                {{ detail.orderNo }}
              </el-col>
              <!-- <el-col :span="12">
              <h3>退费单号</h3>
              {{detail.tradeNo}}
            </el-col> -->
            </el-row>

            <el-row>
              <el-col :span="12">
                <h3>退费金额</h3>
                {{ prices }}
              </el-col>
              <el-col :span="12">
                <h3>申请时间</h3>
                {{ formatDate(new Date(), "yyyy-MM-dd") }}
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <h3>人员明细</h3>
                <el-table :data="multipleSelection" size="medium">
                  <el-table-column prop="userName" width="100px" label="姓名">
                  </el-table-column>
                  <el-table-column prop="userGender" width="100px" label="性别">
                  </el-table-column>
                  <el-table-column
                    prop="userMobile"
                    width="150px"
                    label="手机号"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="userEmail"
                    width="200px"
                    label="电子邮箱"
                  >
                  </el-table-column>
                  <el-table-column prop="userCompany" label="工作单位">
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <h3>退费原因</h3>
                <el-select v-model="form.reason" placeholder="请选择">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="20">
                <h3>备注</h3>
                <el-input
                  type="textarea"
                  :rows="2"
                  v-model="form.remarks"
                  placeholder="请输入内容"
                >
                </el-input>
              </el-col>
            </el-row>
          </div>

          <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" :loading="tuiloading" @click="handsubs"
              >确 定</el-button
            >
          </span>
        </el-dialog>

        <el-dialog
          title="提示"
          :visible.sync="centerDialogVisible"
          :close-on-click-modal="false"
          width="30%"
          center
        >
          <span>此订单有已开具的发票，请先作废。确认是否要作废发票？</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取 消</el-button>
            <el-button type="primary" :loading="zuloading" @click="submust"
              >确 定</el-button
            >
          </span>
        </el-dialog>

        <el-dialog title="明细" width="750px" :visible.sync="outerVisible">
          <el-table :data="gridData">
            <el-table-column prop="userName" width="100px" label="姓名">
            </el-table-column>
            <el-table-column prop="userGender" width="100px" label="性别">
            </el-table-column>
            <el-table-column prop="userMobile" width="150px" label="手机号">
            </el-table-column>
            <el-table-column prop="userEmail" width="200px" label="电子邮箱">
            </el-table-column>
            <el-table-column prop="userCompany" label="工作单位">
            </el-table-column>
          </el-table>

          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="outerVisible = false"
              >确定</el-button
            >
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
  
  <script>
import api from "../../api";
import cookie from "@/api/cookie";
import { dateFormat } from "@/utils/dateFormat.js";
import * as dayjs from "dayjs";
export default {
  data() {
    return {
      id: "",
      dialogVisible: false, //弹出层
      centerDialogVisible: false, //作废的flog
      outerVisible: false, //明雄的flog
      gridData: [], //人员明细
      zuloading: false,
      tuiloading: false,
      userData: [], //已支付数据
      tuifData: [], //退费数据
      activeName: "first",
      multipleSelection: [], //选中的值
      detail: {},
      options: [
        {
          value: "报错培训班",
          label: "报错培训班",
        },
        {
          value: "个人原因退费",
          label: "个人原因退费",
        },
      ],
      // 表单信息
      form: {
        reason: "",
        remarks: "",
      },
    };
  },
  mounted() {
    this.init();
  },
  computed: {
    prices() {
      return this.detail.price * this.multipleSelection.length;
    },
  },
  methods: {
    init() {
      this.id = this.$route.query.id;
      this.getdetai();
      this.getData();
      this.getRefound();
    },
    getdetai() {
      api.getorderDetail(this.id).then((res) => {
        console.log(res, "我是订单的信息");
        this.detail = res.data;
      });
    },
    getData() {
      api.getWaitingForRefundUser(this.id).then((res) => {
        console.log("userOrderById", res);
        this.userData = res.data;
        // if (res.code === 200 && res.data) {
        //   res.data.forEach((e) => {
        //     console.log(e.reUserId);
        //     api.getUserInfo(e.reUserId).then((res1) => {
        //       // console.log('userProfile', res1.data)
        //       this.userData.push(res1.data);
        //       console.log(res1,'我是啥信息？？');
        //     });
        //   });
        // }
      });
    },
    getRefound() {
      api.getRefund({ orderId: this.id }).then((res) => {
        console.log(res, "我是退费的订单");
        this.tuifData = res.data;
      });
    },

    // 申请退费
    async Applyreud() {
      // console.log(this.detail, "我找不到了？？");

      const targetDate = new Date("2024-02-19").getTime(); // 2024年2月19日的时间戳
      if (this.detail.createTime < targetDate) {
        return this.$message({
          type: "error",
          message: "老订单请联系客服处理开票和退费事宜",
        });
      }
      if (
        this.detail.userInvoicesId != null &&
        this.detail.userInvoicesId != 0
      ) {
        let res = await api.selectDetailByOrderId(this.detail.ordersId);
        if (res.data.syncStatus == 20 || res.data.syncStatus == -1) {
          return (this.centerDialogVisible = true);
        }
      }
      this.tuiloading = false;
      this.dialogVisible = true;
    },

    // 表格change事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 切换tabs的时候
    handleClick(tab, event) {
      console.log(tab, event);
    },
    // 申请退费ok
    handsubs() {
      this.tuiloading = true;
      let poars = {
        orderId: this.id,
        userIds: [],
      };
      poars = Object.assign(poars, this.form);
      poars.userIds = this.multipleSelection.map((item) => {
        return item.userId;
      });
      api
        .addRefund(poars)
        .then((res) => {
          console.log("我申请退费了好吧");
          this.$message("申请退费成功");
          this.dialogVisible = false;
          this.rest();
          this.getData();
          this.getRefound();
        })
        .finally(() => {
          this.tuiloading = false;
        });
    },
    formatDate(timestamp, foat) {
      return dayjs(timestamp).format("YYYY-MM-DD");
    },
    // 退费取消
    handleClose() {
      console.log(this.form, "我无语了");
      this.rest();
      this.dialogVisible = false;
    },
    // 确定作废发票
    submust() {
      this.zuloading = true;
      api
        .cancelByOrderId(this.detail.ordersId)
        .then((res) => {
          this.centerDialogVisible = false;
          this.dialogVisible = true;
          this.$message("作废成功");
        })
        .finally((res) => {
          this.zuloading = false;
        });
    },
    // 查看明细
    mingxi(row) {
      api.queryByRefundId(row.refundId).then((res) => {
        this.gridData = res.data;
        this.outerVisible = true;
      });
    },
    rest() {
      this.form = {
        reason: "",
        remarks: "",
      };
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.container {
  width: 1200px;
  margin: 20px auto;
  padding: 20px;
  background: #ffffff;
  min-height: 700px;
}

.ntns {
  margin-top: 40px;
  display: flex;
  flex-direction: row-reverse;
}

::v-deep .el-button--primary {
  background: #264f99;
}

.el-button--primary.is-disabled,
.el-button--primary.is-disabled:active,
.el-button--primary.is-disabled:focus,
.el-button--primary.is-disabled:hover {
  background: #d4dceb;
  border-color: #d4dceb;
}

.car-title {
  position: relative;
  text-align: left;
  padding-left: 8px;
  height: 22px;
  font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
  font-weight: 400;
  font-size: 16px;
  color: #264f99;
  line-height: 22px;
  text-align: justify;
  font-style: normal;
  margin-bottom: 20px;
}
.car-title::before {
  content: "";
  width: 4px;
  height: 12px;
  background: #264f99;
  display: block;
  position: absolute;
  top: 6px;
  left: 0px;
}

::v-deep .has-gutter {
  .el-table__cell {
    background: #f6f7fb;
  }
}

::v-deep .el-table--border .el-table__cell,
.el-table__body-wrapper .el-table--border.is-scrolling-left ~ .el-table__fixed {
  border-right: none;
}

::v-deep .el-form-item__content {
  display: flex;
  align-items: center;
}
::v-deep .el-tabs__item.is-active {
  color: #264f99;
}

::v-deep .el-tabs__active-bar {
  background: #264f99;
}
</style>

